import { css } from '@emotion/css';
import { darken } from 'polished';

export const filterBtn = (params) => css`
  cursor: pointer;
  background: ${params?.hasDarkerGradient
    ? `linear-gradient(180deg, ${params?.backgroundColor} 0%,
      ${darken(0.2, params?.backgroundColor || '#000000')} 100%)`
    : params?.backgroundColor || 'transparent'};
  border-width: ${params?.borderSize};
  border-color: ${params?.borderColor};
  border-style: solid;
  color: ${params?.textColor};
  font-weight: ${params?.fontWeight};
  height: fit-content;
  width: ${params?.buttonSize};
  border-radius: ${params?.borderRadius};
  padding: ${params?.padding};
  ${params?.isMobile ? (
    `font-size: ${params?.mobileFontSize};`
  ) : (
    `font-size: ${params?.pcFontSize};`
  )}
  text-align: ${params?.textAlign};
  outline: transparent;

  &:disabled {
      opacity: 0.4;
      cursor: default;
  }

  &:hover {
    ${params?.hoverBackgroundColor && (`
      background: ${params?.hasDarkerGradient
      ? `linear-gradient(180deg, ${params?.hoverBackgroundColor || 'transparent'} 0%,
        ${darken(0.2, params?.hoverBackgroundColor || '#000000')} 100%)`
      : params?.hoverBackgroundColor || 'transparent'};
    `)}
    ${params?.hoverBorderColor && (`
      border-color: ${params?.hoverBorderColor};
    `)}
    ${params?.hoverTextColor && (`
      color: ${params?.hoverTextColor};
    `)}
  }

  ${params?.hasDropShadow && (
    'box-shadow: 1px 5px 6px -2px #000000;'
  )}
  ${params?.transitionTime && (
    `transition: all ${params?.transitionTime} ease;`
  )}
`;
